import { render } from "./ListArticle.vue?vue&type=template&id=1e86a9f6"
import script from "./ListArticle.vue?vue&type=script&lang=js"
export * from "./ListArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__